@if (isInitialized) {
  <oe-chart [title]="component.alias">
    <controller-io-heatingelement-chart [isOnlyChart]="true" [component]="component">
    </controller-io-heatingelement-chart>
  </oe-chart>
}
